/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import useTranslation from 'Hooks/useTranslation';
import DropzoneAreaLoadingIndicator from 'Pages/EditCourseLessons/Components/DropzoneAreaLoadingIndicator';
import { DropzoneContainer, DropzoneSubContainer, VideoContainer, videoStyle } from './style';

const selectContent = ({
  urlVideo,
  getInputProps,
  getRootProps,
  loading,
  uploadFiles,
  acceptedFileItems,
  fileRejectionItems,
}) => {
  const { t2 } = useTranslation('EditCourse');

  if (urlVideo === null)
    return (
      <>
        <DropzoneContainer>
          <DropzoneSubContainer>
            <DropzoneAreaLoadingIndicator
              descriptions={{
                loadingDescription: t2('UploadAudio'),
                dragAndDropDescription: t2('DragAndDropAudio'),
                typeErrorDescription: t2('TypeErrorAudio'),
              }}
              getInputProps={getInputProps}
              getRootProps={getRootProps}
              loading={loading}
              uploadFiles={uploadFiles}
              acceptedFileItems={acceptedFileItems}
              fileRejectionItems={fileRejectionItems}
            />
          </DropzoneSubContainer>
        </DropzoneContainer>
        <p>{t2('TypeExtensionsAudio')}</p>
      </>
    );

  return (
    <VideoContainer>
      <audio controls src={urlVideo} style={videoStyle} />
    </VideoContainer>
  );
};

export default selectContent;
